
export const ROUTES = {
  ANY: '*',
  ROOT: '/',
  HOME: '/home',
  AUTENTICAZIONE: '/autenticazione',
  AUT_NON_RICONOSCIUTO: '/autenticazione/non-riconosciuto',
  AUT_CODICE_SCADUTO: '/autenticazione/codice-scaduto',
  AUT_CODICE_INVALIDO: '/autenticazione/codice-non-valido',
  MY_PROFILE: '/my-profile',
  MP_UPDATED: '/my-profile/updated',
  MP_DELETE: '/my-profile/delete',
  MP_DELETED: '/my-profile/deleted',
  GENERIC_ERROR:'/generic-error'
}
export const URLS = {
  GENERATE_OTP: '/wificonsents/otp/generate',
  VERIFY_OTP: '/wificonsents/otp/verify',
  GET_CONSENTS: '/wificonsents/consents/get',
  UPDATE_CONSENTS: '/wificonsents/consents/update',
  DELETE_CONSENTS: '/wificonsents/consents/delete'
}
export const PHONE_REGEX = /^([+]\d{2})?\d{10,11}$/;
export const OTP_REGEX = /^\d{6}$/;
